export default "__VITE_ASSET__ab933365__"